<template>
  <div class="nav-wrapper">
    <v-navigation-drawer v-model="drawer" app :disable-resize-watcher="true" :mini-variant="miniMenu" permanent>
      <v-list-item>
        <img @click="$router.push({ name: 'HomePage' }).catch(() => {})" :src="logoSymbolImage" v-if="miniMenu" class="logo-symbol" link />
        <v-list-item-content>
          <img link v-if="!miniMenu" @click="$router.push({ name: 'HomePage' }).catch(() => {})" class="logo" :src="logoImage" />
        </v-list-item-content>
      </v-list-item>

      <v-list dense>
        <template v-for="(routeGroup, i) in routesGrouped">
          <template v-for="route in routeGroup">
            <v-list-item link :to="route.to" :key="route.name">
              <v-list-item-action v-tooltip="route.title">
                <v-icon>{{ route.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ route.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
          <v-divider class="my-4" :key="i + '-group'" v-if="routesGrouped.length > i + 1" />
        </template>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app color="#fff" light elevation="1">
      <v-app-bar-nav-icon @click.stop="miniMenu = !miniMenu" />
      <v-toolbar-title class="hidden-xs-only menu-title"> {{ $store.state.config.customDashboardConfig.appTitle }} </v-toolbar-title>
      <v-spacer></v-spacer>

      <template v-if="$store.state.config.userObject != null && $vuetify.breakpoint.smAndUp"> </template>
      <v-menu right bottom offset-y>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" class="me-0" icon elevation="0">
            <v-icon large>mdi-account-circle</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item v-if="$store.state.config.userObject">
            <v-list-item-content>
              <v-icon large slot="start">mdi-account-circle</v-icon>
              <v-list-item-title class="subtitle-1 text-center">
                {{ $store.state.config.userObject.name }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider class=""></v-divider>
          <v-list-item @click="logout()">
            <v-list-item-title>
              <v-icon left>mdi-logout-variant</v-icon>
              Logout
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
  </div>
</template>

<script>
import { routesData } from '../../../../dashboard-config/routes-config.js';
import { generateNavigationMenuData } from '@/utils/custom-components-functions.js';
export default {
  data() {
    return {
      routesGrouped: generateNavigationMenuData(routesData),
      drawer: true,
      loadWatch: true,
      miniMenu: false,
      logoImage: this.$store.state.config.customDashboardConfig.logoImage,
      logoSymbolImage: this.$store.state.config.customDashboardConfig.logoSymbolImage
    };
  },
  components: {},
  computed: {
    screenSmallerThanMedium() {
      return this.$vuetify.breakpoint.mdAndDown;
    }
  },
  watch: {
    screenSmallerThanMedium: {
      immediate: true,
      handler(n, o) {
        if (n != o) this.miniMenu = n;
      }
    }
  },
  created() {},
  mounted() {
    //this.drawer = this.$vuetify.breakpoint.mdAndDown ? false : true;
  },
  methods: {
    logout() {
      localStorage.removeItem('dashboard-dvg-kc-token'); //offline_token
      localStorage.removeItem('dashboard-dvg-kc-refresh-token'); //offline_token
      this.$store.state.config.keycloak.kc.logout();
    }
  }
};
</script>

<style lang="scss">
.nav-wrapper {
  .v-toolbar__title {
    overflow: visible;
  }
  .logo {
    max-width: 160px;
    justify-self: center;
    margin: 8px 0 8px 20px;
    &:hover {
      cursor: pointer;
    }
  }
  .logo-symbol {
    width: 34px;
    margin-left: -6px !important;
  }

  .menu-title {
    margin-left: 10px;
    margin-top: 0px;
    padding-left: 10px;
    font-size: 16px !important;
    border-left: 2px solid;
    text-transform: uppercase;
    font-weight: 600;
    padding: 6px 10px;
    border-left: 1px solid lighten(grey, 20%);
    color: grey;
  }

  .v-list-item--active {
    color: var(--v-primary-base) !important;
    &:before {
      background: none;
    }
  }
}
</style>
